import React from 'react';

import styled from 'styled-components';
import { Divider1, FlexContainer } from 'styles/common';

import { Typography2 } from 'uiToolkit/Typography';

import CommentPreview from './questionPreviewComps/CommentPreview';
import EmojiPreview from './questionPreviewComps/EmojiPreview';
import EngagementSelectPreview from './questionPreviewComps/EngagementSelectPreview';
import MultiSelectPreview from './questionPreviewComps/MultiSelectPreview';
import NumberRatingPreview from './questionPreviewComps/NumberRatingPreview';
import OneOnOneEmojiPreview from './questionPreviewComps/OneOnOneEmojiPreview';
import PulseNumberRatingPreview from './questionPreviewComps/PulseNumberRatingPreview';
import SelectPreview from './questionPreviewComps/SelectPreview';
import StarRatingPreview from './questionPreviewComps/StarRatingPreview';
import TextBoxPreview from './questionPreviewComps/TextBoxPreview';

const PreviewHeading = styled.div`
  background: ${(props) => props.theme.palette.background.lightGrey3};
  border-radius: 14px;
`;
const PreviewDivider = () => (
  <FlexContainer style={{ alignItems: 'center', padding: '32px 0 60px' }}>
    <Divider1 style={{ flexGrow: 1 }} />
    <PreviewHeading>
      <Typography2 leftGutter={2.25} rightGutter={2.25}>
        This is a preview
      </Typography2>
    </PreviewHeading>
    <Divider1 style={{ flexGrow: 1 }} />
  </FlexContainer>
);

const QuestionPreview = ({ question, showPreviewText = true }) => {
  let PreviewComp = null;

  switch (question.answerType) {
    case 'COMMENT':
      PreviewComp = CommentPreview;
      break;
    case 'STAR_RATING':
      PreviewComp = StarRatingPreview;
      break;
    case 'DROP_DOWN':
      if (question.questionType === 'ENGAGEMENT') {
        PreviewComp = EngagementSelectPreview;
      } else if (question.multiSelect) {
        PreviewComp = MultiSelectPreview;
      } else {
        PreviewComp = SelectPreview;
      }
      break;
    case 'MULTI_SELECT':
      PreviewComp = MultiSelectPreview;
      break;
    case 'NUMBER_RATING':
      PreviewComp = question.questionType === 'ENGAGEMENT' ? PulseNumberRatingPreview : NumberRatingPreview;
      break;
    case 'EMOJI':
      PreviewComp = question.questionType === 'EMOTION' ? OneOnOneEmojiPreview : EmojiPreview;
      break;
    case 'NONE':
      PreviewComp = TextBoxPreview;
      break;
    default:
  }

  if (!PreviewComp) {
    return null;
  }

  return (
    <>
      {showPreviewText && <PreviewDivider />}
      <PreviewComp question={question} />
    </>
  );
};

export default QuestionPreview;
